import styled from 'styled-components';
import { PrimaryButton } from 'ui/button';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/modal';
import { Body2, BoldText } from 'ui/theme';

const ListItem = styled.li`
  list-style-type: disc;
`;

type UnarchiveModalProps = {
  /** Bool to show or hide the modal */
  open: boolean;
  /** Function that closes the modal */
  closeModal: () => void;
  /** Function to call when submit is clicked */
  handleAction: (project: Record<string, any>) => void;
  /** Object that holds the project data */
  project: Record<string, any>;
  /** Name of the organization of the project */
  organizationName: string;
};

export const UnarchiveModal = ({
  closeModal,
  handleAction,
  open = false,
  project = {},
  organizationName,
}: UnarchiveModalProps) =>
  open ? (
    <Modal onClose={closeModal} isModalOpen={open} data-test="UnarchiveModal" id="unarchiveModal">
      <ModalHeader>Unarchive project</ModalHeader>
      <ModalBody>
        <Body2>
          Are you sure you‘d like to unarchive <BoldText>{project.name}</BoldText> (id {project.id})
          in org {organizationName}?
        </Body2>
        <ul>
          <ListItem>All campaigns and workflows will be turned back on.</ListItem>
          <ListItem>All API keys will be re-enabled.</ListItem>
          <ListItem>Members will regain access to the project and its contents.</ListItem>
        </ul>
      </ModalBody>
      <ModalFooter hasCancel onClose={closeModal}>
        <PrimaryButton
          data-test="UnarchiveModal-Submit"
          onClick={() => {
            handleAction({
              ...project,
              extendedProjectSettings: { ...project.extendedProjectSettings, isArchived: false },
            });
            closeModal();
          }}
        >
          Unarchive
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  ) : null;
